// core
import {Injectable} from '@angular/core';

// ngx-bootstrap
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';

// service
import {LineageDataService} from './data.service';

// component
//import { ModalRelationComponent } from '../modal-relation/modal-relation.component';

// class
import {Model} from '../../lineage-path/class/model';
import {Schema} from '../../lineage-path/class/schema';

declare var jsPlumb: any;

@Injectable()
export class LineageJsPlumbService {

    private _instance: any;
    private bsModalRef: BsModalRef;

    constructor(private dataService: LineageDataService, private bsModalService: BsModalService) {
    }

    public init(): void {
        //console.log('JsPlumbService.init() is called!');

        this._instance = jsPlumb.getInstance({
            Container: 'canvas',
            Anchor: ['RightMiddle', 'LeftMiddle'],
            Endpoint: ['Dot', {radius: 3}],
            //connector: ["Flowchart", { anchors: ["Bottom", "Top"] }],
            //Connector: ['Flowchart', {anchors: ['RightMiddle', 'LeftMiddle']}],
            ConnectionsDetachable: false,
        });
    }

    public initModel(model: Model): void {

        //console.log('JsPlumbService.initModel() is called!');
        //console.log(this._instance);
        // draggable
        this._instance.draggable(model.getElementId());
        this._instance.toggleDraggable(model.getElementId());

        if (model.belongsTo) {
            this.createConnection(this.dataService.data.getModelByName(model.belongsTo), model);
        }

        // add endpoint
        if (model.is_pivot === false) {

            this._instance.addEndpoint(model.getElementH2Id(), {
                isSource: true,
                isTarget: true,
                cssClass: 'model-default-endpoint',
                beforeDrop: (params) => {
                    //console.log('event[red - beforeDrop] is called!');
                    // this.bsModalRef = this.bsModalService.show(ModalRelationComponent, {
                    //     initialState: {
                    //         source_model: this.dataService.data.getModelByElementH2Id(params.sourceId),
                    //         target_model: this.dataService.data.getModelByElementH2Id(params.targetId)
                    //     }
                    // });
                    return false;
                },
            });
        }

        // load jsplumb connection
        for (let i = 0; i < this.dataService.data.models.length; i++) {
            for (let j = 0; j < this.dataService.data.models[i].schemas.length; j++) {
                this.initSchema(this.dataService.data.models[i].schemas[j]);
            }
        }

        // if (model.belongsTo) {
        //     this.createConnection(this.dataService.getModelByName(model.belongsTo), model);
        // }
    }

    public destroyModel(model: Model) {

        // delete myself endpoint
        this._instance.selectEndpoints({
            source: model.getElementH2Id()
        }).delete();

        // check connection exists as destroy-model source
        var connections_to_delete = this._instance.getConnections({
            source: model.getElementH2Id()
        });

        for (let i = 0; i < connections_to_delete.length; i++) {
            var schema_to_delete = this.dataService.data.getSchemaByElementId(connections_to_delete[i].targetId);
            if (schema_to_delete) {
                this.dataService.deleteSchema(schema_to_delete);
            }
        }
    }


    public createConnection(sourceModel: Model, targetModel: Model) {
        //console.log(sourceModel);
        //console.log(targetModel);
        //console.log(sourceModel.getElementH2Id());
        //console.log(targetModel.getElementH2Id());
        this._instance.connect({
            source: sourceModel.getElementH2Id(),
            target: targetModel.getElementH2Id(),
            anchors: ['Right', 'Left']
        });
    }


    public initSchema(schema: Schema) {

        //console.log('JsPlumbService.initSchema() is called!');
        //console.log(schema.belongsto);
        if (schema.belongsto) {

            var source_id = this.dataService.data.getModelByName(schema.belongsto).getElementH2Id();
            var target_id = schema.getElementId();
            var option = {
                source: source_id,
                target: target_id
            };


            if (this._instance.getConnections(option).length === 0) {
                this._instance.connect(option);
                //console.log('schema connected!(' + source_id + '--->' + target_id + ')');
            } else {
                //console.log('schema is already connected!(' + source_id + '--->' + target_id + ')');
            }
        }
        this.dataService.flg_repaint = true;
    }

    public destroySchema(schema: Schema) {

        //console.log('JsPlumbService.destroySchema() is called!');

        if (schema.belongsto) {
            var option = {
                target: schema.getElementId()
            };
            var connections_to_delete = this._instance.getConnections(option);
            for (let i = 0; i < connections_to_delete.length; i++) {
                this._instance.deleteConnection(connections_to_delete[i]);
            }
        }
    }

    public toggleDraggable(model: Model): void {

        //console.log('JsPlumbService.toggleDraggable() is called!');
        this._instance.toggleDraggable(model.getElementId());
    }

    public repaintEverything(): void {

        //console.log('JsPlumbService.repaintEverything() is called!');
        this._instance.repaintEverything();
    }

    public deleteAll(): void {

        //console.log('JsPlumbService.deleteAll() is called!');
        this._instance.deleteEveryEndpoint();
    }
}
